import { render, staticRenderFns } from "./RoadUserAccidentList.vue?vue&type=template&id=95879032"
import script from "./RoadUserAccidentList.vue?vue&type=script&lang=js"
export * from "./RoadUserAccidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports